import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
// import App from './App';
import * as serviceWorker from './serviceWorker';
import { BrowserRouter, Route } from 'react-router-dom';
import SimpleForm from './component/chatBot';
import Auth from './component/auth';
import NotAuthorized from './component/401';

ReactDOM.render(
  <BrowserRouter>
    <Route exact path='/' component={Auth}/>
    <Route exact path='/401' component={NotAuthorized}/>
    <Route exact path='/chat' component={SimpleForm}/>
  </BrowserRouter>
  , document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
